export default __webpack_public_path__ + "de42fb710488a26c530b4fe0ddde02d4.svg";